module.exports = __webpack_public_path__ + "annualreview2017/static/img/paul-jeffery.0aa3409.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/board/paul-jeffery.jpg
// module id = 697
// module chunks = 0